<template>
  <div class="product-tax-and-shipping">
    <i18n-t
      class="p-tax-info"
      keypath="product.taxes.all"
      tag="span"
    >
      <template #link>
        <fn-link
          no-arrow
          icon
          @click.prevent="$emit('changeTab', 'detailedShippingInformation')"
        >
          {{ $t('product.taxes.link') }}
        </fn-link>
      </template>
    </i18n-t>
  </div>
</template>

<script>
export default {
  emits: ['changeTab'],
};
</script>

<style lang="scss" scoped>
.product-tax-and-shipping {
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  text-align: right;
  font-size: map-get($font-sizes, 'm');
  color: palette(content, secondary);
}
</style>
